import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Calendar14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M4 7C4.55228 7 5 6.55228 5 6C5 5.44772 4.55228 5 4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7Z'
      fill='currentColor'
    />
    <path
      d='M8 6C8 6.55228 7.55228 7 7 7C6.44772 7 6 6.55228 6 6C6 5.44772 6.44772 5 7 5C7.55228 5 8 5.44772 8 6Z'
      fill='currentColor'
    />
    <path
      d='M4 10C4.55228 10 5 9.55228 5 9C5 8.44772 4.55228 8 4 8C3.44772 8 3 8.44772 3 9C3 9.55228 3.44772 10 4 10Z'
      fill='currentColor'
    />
    <path
      d='M8 9C8 9.55228 7.55228 10 7 10C6.44772 10 6 9.55228 6 9C6 8.44772 6.44772 8 7 8C7.55228 8 8 8.44772 8 9Z'
      fill='currentColor'
    />
    <path
      d='M10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5C9.44771 5 9 5.44772 9 6C9 6.55228 9.44771 7 10 7Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.75 1.25H12.625C13.2641 1.25 13.75 1.776 13.75 2.38462V11.6154C13.75 12.224 13.2641 12.75 12.625 12.75H1.375C0.735893 12.75 0.25 12.224 0.25 11.6154V2.38462C0.25 1.776 0.735893 1.25 1.375 1.25H3.25V0.5H4.75V1.25H9.25V0.5H10.75V1.25ZM3.25 2.75V3.5H4.75V2.75H9.25V3.5H10.75V2.75H12.25V11.25H1.75V2.75H3.25Z'
      fill='currentColor'
    />
  </Svg>
);

Calendar14.displayName = 'Calendar14';
export default Calendar14;
